import { useMutation } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'
import { BrandError } from '~/supabase/types'

export const useNotifyError = () => {
  return useMutation({
    mutationKey: ['notify-error'] as const,
    mutationFn: async (
      payload: Omit<BrandError, 'id' | 'created_at' | 'error'> & { error: unknown }
    ) => {
      const { error, data } = await supabaseApi
        .from('brand_error_logs')
        .insert({ ...payload, error: JSON.stringify(payload.error) })
        .select()
        .single()

      let body

      if (error) {
        body = error
      } else {
        body = `https://admin.wollem.com/json?id=${data.id}`
      }

      return await fetch('/api/send_email', {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      })
    },
  })
}
